import { AlpineComponent } from "@nxtlvlsoftware/alpine-typescript";
import { FormsService } from "./forms-api";

export class FormComponent extends AlpineComponent {
    private formId: string;
    private contentId?: string;
    private headers: Record<string, string> = {};
    private values: Record<string, string[]> = {};
    
    public formSubmitted: boolean = false;
    public errors: Record<string, string[]> = {};
    public statusMessage?: string;
    public statusMessageIsHtml: boolean = false;

    //public open: Boolean = false;

    constructor(afHeaderName: string, afHeaderValue: string, formId: string, contentId: string, pageName: string) {
        super();
        this.formId = formId;
        this.contentId = contentId;
        this.headers = {
            ["Content-Type"]: "application/json",
            [afHeaderName]: afHeaderValue
        };
        this.values["pageName"] = [pageName];
    }

    protected submitButton = this.binding({
        ["x-on:click"]() {
            this.submit();
        }
    });

    public async submit() {

        const { data, error } = await FormsService.postUmbracoFormsDeliveryApiV1EntriesById({
            method: 'POST',
            headers: this.headers,
            path: {
                id: this.formId
            },
            body: {
                values: this.values,
                contentId: this.contentId
            }
        });

        if (data) {
            this.formSubmitted = true;
            const response = data as { messageOnSubmit: string, messageOnSubmitIsHtml: boolean };
            this.statusMessage = response.messageOnSubmit;
            this.statusMessageIsHtml = response.messageOnSubmitIsHtml;
            this.errors = {};
        } else if (error) { 
            const err = error as { errors: Record<string, string[]>, statues: number, title: string };
            this.errors = err.errors;
            this.statusMessage = err.title;
            this.statusMessageIsHtml = false;
            console.error(err.title);
        }
    }
}